import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { VariableSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, VariablesFilterSchema } from "../ea.schema.query";

const base = "variables";
const vars = createEndpointBase(base);

export const variablesEndpoints = {
  variablesGet: vars({
    method: "GET",
    path: "",
    request: z.object({ filter: VariablesFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(VariableSchemas["general"]),
    description: "Retrieves a list of local variables with filtering support.",
  }),
  variablesCount: vars({
    method: "GET",
    path: "count",
    request: z
      .object({ filter: VariablesFilterSchema.pick({ where: true }).optional() })
      .optional(),
    response: CountResponseSchema,
    description: "Returns the total number of local variables matching the filters.",
  }),
  variablesCreate: vars({
    method: "POST",
    path: "",
    request: VariableSchemas["createData"],
    response: z.any(),
    description: "Creates a new local variable.",
  }),
  variablesUpdate: vars({
    method: "PATCH",
    path: ":id",
    request: VariableSchemas["update"],
    response: z.any(),
    description: "Updates an existing local variable.",
  }),
  variablesDelete: vars({
    method: "DELETE",
    path: ":id",
    request: VariableSchemas["general"].pick({ id: true }),
    response: z.any(),
    description: "Permanently deletes the specified local variable.",
  }),
  variablesPatchDiff: vars({
    method: "PATCH",
    path: "diff",
    request: VariableSchemas["patchDiff"],
    response: z.any(),
    description: "Calculates differences and patches local variables.",
  }),
} as const;
